import styled from "styled-components";
import { breakpoint } from "@utilities";

export const StyledDatePicker = styled.div`
    .MuiInputBase-root {
        font-size: 16px !important;
    }

    .MuiInput-underline:after,
    .MuiInput-underline:before {
        display: none !important;
    }

    .MuiInputBase-input {
        font-family: Poppins;
        color: ${(props) => props.theme.colors.gray_3};

        ${breakpoint.breakTablet`
            font-size: 12px !important;
        `}

        ${breakpoint.breakIpadPro`
            font-size: 16px !important;
        `}
    }

    .MuiIconButton-label {
        width: 100%;

        ${breakpoint.breakTablet`
            width: 60%;
        `}

        ${breakpoint.breakIpadPro`
            width: 100%;
        `}
    }

    .MuiInputLabel-animated {
        font-size: 16px;
        font-weight: 100;
        color: ${(props) => props.theme.colors.gray_2};
    }

    .MuiInputLabel-root.Mui-focused {
        color: ${(p) => p.theme.colors.highlight};
        border-color: ${(p) => p.theme.colors.highlight};
    }
    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: ${(p) => p.theme.colors.highlight};
    }
    .MuiSvgIcon-root {
        color: ${(p) => p.theme.colors.main};
    }

    label + .MuiInput-formControl {
        margin-top: 24px;
    }
`;
